var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.875,
    cy: 14,
    r: 14,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0602 22.7033H11.0122L10.8342 16.1093V16.0973L10.7842 13.8693C10.7682 13.1333 10.9402 12.4013 11.2842 11.7513C11.6242 11.1073 12.1242 10.5573 12.7302 10.1593C12.7762 10.1293 12.8002 10.0833 12.8002 10.0253L12.7182 4.86328H16.3642L16.2822 10.0253C16.2822 10.0813 16.3062 10.1273 16.3522 10.1593C16.9582 10.5593 17.4582 11.1093 17.7982 11.7513C18.1422 12.4013 18.3142 13.1333 18.2982 13.8693L18.0602 22.7033ZM11.4002 22.3053H17.6742L17.9022 13.8593C17.9182 13.1933 17.7602 12.5273 17.4482 11.9373C17.1402 11.3533 16.6862 10.8533 16.1342 10.4913C15.9722 10.3853 15.8822 10.2133 15.8842 10.0193L15.9602 5.26328H13.1222L13.1982 10.0193C13.2022 10.2093 13.1082 10.3873 12.9482 10.4913C12.3982 10.8533 11.9442 11.3533 11.6342 11.9373C11.3222 12.5273 11.1662 13.1913 11.1802 13.8593L11.2302 16.0973V16.1093L11.3962 22.3053H11.4002Z",
    fill: "#E85665"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.464 13.8492L17.248 21.8672H11.828L11.672 16.1112C11.672 16.1112 11.672 16.0932 11.672 16.0852L11.622 13.8492C11.608 13.2552 11.748 12.6652 12.026 12.1412C12.3 11.6232 12.704 11.1772 13.192 10.8552C13.478 10.6672 13.644 10.3512 13.638 10.0112L13.568 5.69922H15.516L15.446 10.0112C15.44 10.3532 15.608 10.6692 15.892 10.8552C16.382 11.1772 16.784 11.6212 17.058 12.1412C17.336 12.6652 17.474 13.2572 17.462 13.8492H17.464Z",
    fill: "#E85665"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRose);
export default __webpack_public_path__ + "static/media/Rose.711288d15d379ea39cb16842089b5986.svg";
export { ForwardRef as ReactComponent };